import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import {
  AssistantChatProvider,
  CalendarProvider,
  CircadianProvider,
  MetricsProvider,
  TodoTasksProvider,
  WearablesProvider,
  useSyncOnFirstRender,
} from '../data-access';

const SyncBootstrapper = () => {
  useSyncOnFirstRender();
  return null;
};

export const BasisProvider: FC = () => {
  return (
    <WearablesProvider>
      <CalendarProvider>
        <TodoTasksProvider>
          <CircadianProvider>
            <MetricsProvider>
              <AssistantChatProvider>
                <SyncBootstrapper />
                <Outlet />
              </AssistantChatProvider>
            </MetricsProvider>
          </CircadianProvider>
        </TodoTasksProvider>
      </CalendarProvider>
    </WearablesProvider>
  );
};
